module.exports = __webpack_public_path__ + "static/img/wealth_level_51.9f2c024.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_51.png
// module id = Fnwo
// module chunks = 0